
import React, { useEffect, useState } from 'react';
import { getregister, getregisterfilter, getcaste, getmyprofile, savewishlists, getsavedprofiles } from "./../action/user";
import { useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Circles } from 'react-loader-spinner'
import FavoriteIcon from '@mui/icons-material/Favorite';
import './freesearch.css';
import InfiniteScroll from "react-infinite-scroller";
import { useInfiniteQuery, useQuery } from "react-query";
import config from "../../lib/config";
import './freesearch.css'
import AOS from 'aos'
import Pagination from '@material-ui/lab/Pagination';
import whyeliteRight from "../../assests/images/whyelite-right.png";
import { toast } from 'react-toastify';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

function Freesearch(props) {

    const search = useLocation().search;
    const params = new URLSearchParams(search);

    const [page, setPage] = useState(1);
    const [sexparam, setSexparam] = useState("");
    const [malecount, setMalecount] = useState(0);
    const [femalecount, setFemalecount] = useState(0);
    const [totalProfileCount, setTotalProfileCount] = useState(0);
    const [userprofile, setUserprofile] = useState({});
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [savedProfiles, setSavedProfiles] = useState(new Set());
    const [membershipcount, setMembershipcount] = useState(0);
    const [membershipparam, setMembershipparam] = useState("");

    const PAGE_SIZE = 20;

    // Build filter object
    const getFilters = () => {
        const filters = { page: page - 1 };

        // Basic params
        if (params.get('userid')) filters.userid = params.get('userid');
        if (params.get('castename')) filters.castename = params.get('castename');
        if (params.get('sex')) filters.sex = params.get('sex');
        if (sexparam) filters.sex = sexparam;

        // Other URL filters
        const keys = ['religion', 'city', 'subcaste', 'maritalname', 'educ', 'zodiacname', 'starname', 'membership'];
        keys.forEach(key => {
            if (params.get(key)) filters[key] = params.get(key);
        });

        if (params.get('castenone')) filters.castenone = "Yes";
        if (params.get('handireason')) filters.handireason = "Yes";

        // Age filter
        const currentYear = new Date().getFullYear();
        if (params.get('age1')) filters.yearto = currentYear - parseInt(params.get('age1'));
        if (params.get('age2')) filters.yearfrom = currentYear - parseInt(params.get('age2'));

        if (params.get('membership')) filters.membership = params.get('membership');
        if (membershipparam) filters.membership = membershipparam;
        return filters;
    };

    // Fetch data with react-query
    const { data, isLoading, isError } = useQuery(
        ["profiles", page, sexparam, search, membershipparam],
        async () => {
            const filters = getFilters();
            const res = await getregisterfilter(filters);

            setMalecount(res.Malecount || 0);
            setFemalecount(res.Femaleount || 0);
            setMembershipcount(res.vipcount || 0);
            setTotalProfileCount(res.totalCount || 0);

            return {
                results: res.userValue || [],
                totalCount: res.totalCount || 0
            };
        },
        {
            keepPreviousData: true,
            staleTime: 30000,
        }
    );

    // Calculate total pages from fresh data, fallback safely
    const currentTotalCount = data?.totalCount ?? totalProfileCount;
    const totalPages = Math.ceil(currentTotalCount / PAGE_SIZE);

    // Show pagination if there are multiple pages OR if loading (to avoid flicker)
    const shouldShowPagination = isLoading
        ? (totalProfileCount > PAGE_SIZE)
        : (currentTotalCount > PAGE_SIZE);

    // Handle page change
    const handlePageChange = (event, value) => {
        setPage(value);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Load user & saved profiles
    useEffect(() => {
        const token = localStorage.getItem("user_token");
        if (!token) return;

        setIsLoggedIn(true);

        const loadData = async () => {
            try {
                const [profile, saved] = await Promise.all([getmyprofile(), getsavedprofiles()]);
                setUserprofile(profile.userValue || {});

                if (saved?.userValue) {
                    const ids = saved.userValue
                        .map(item => item.wishlists?._id)
                        .filter(Boolean);
                    setSavedProfiles(new Set(ids));
                }
            } catch (err) {
                console.error("Failed to load user data", err);
            }
        };

        loadData();

        // Set initial gender from URL
        const urlSex = params.get('sex');
        if (urlSex) setSexparam(urlSex);

        const urlMembership = params.get('membership');
        if (urlMembership) setMembershipparam(urlMembership);
        console.log({ params });
    }, []);

    // Reset to page 1 when gender changes
    useEffect(() => {
        setPage(1);
    }, [sexparam, membershipparam]);

    const savefavprofile = async (id) => {
        if (!isLoggedIn) {
            toast.error("Please login to save profile");
            return;
        }
        try {
            await savewishlists(id);
            setSavedProfiles(prev => new Set([...prev, id]));
            toast.success("Saved Successfully!");
        } catch (err) {
            toast.error("Failed to save");
        }
    };

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    return (
        <>
            <div className="free-b" >
                <div className="container">
                    <div className="text-center" style={{ marginTop: '20px', marginBottom: '80px' }}>
                        <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                            <div className="col-md-12 prink" style={{ marginTop: '35px' }}>
                                <div className="row">
                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSexparam("Male")
                                                setMembershipparam("");
                                            }}
                                            className={`btn btn-sa ${sexparam === "Male" && membershipparam !== "VIP" ? 'active' : ''}`}
                                            style={{ marginRight: '15px' }}
                                        >
                                            Male ({malecount})
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSexparam("Female")
                                                setMembershipparam("");
                                            }}
                                            className={`btn btn-sa ${sexparam === "Female" && membershipparam !== "VIP" ? 'active' : ''}`}
                                        >
                                            Female ({femalecount})
                                        </button>
                                        {userprofile.membership === "VIP" && (
                                            <button type="button"
                                                className={`btn btn-sa ${membershipparam === "VIP" ? 'active' : ''}`}
                                                style={{ marginLeft: '15px' }}
                                                onClick={() => setMembershipparam("VIP")}
                                            >
                                                VIP Members ({membershipcount})
                                            </button>
                                        )}
                                    </div>


                                    {/* <div className="col-md-4">
                     <label style={{ paddingBottom:"8px", fontSize:"18px", fontWeight:"800"}}>தேடுவது </label>
                                        <Autocomplete
                                                options={sexch}
                                                // noOptionsText="Enter to create a new option"
                                                getOptionLabel={(option) => option.title}
                                                onChange={(event, newValue) => {

                                                    setsexparam(newValue.value);

                                                }}
                                                type="text"
                                                name="sex"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label=""
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                    </div>  */}
                                </div>
                            </div>
                            {isLoading && <div style={{ TextAlign: "center" }}>
                                <Circles className="satta" color="red" height={50} width={50} />
                            </div>}
                            {isLoading ? (
                                <p></p>
                            ) : isError ? (
                                <p>There was an error</p>
                            ) : (
                                // <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage}>
                                <div>
                                    {
                                        // data?.pages?.map(page => (
                                        data?.results?.length ? data?.results?.map((post) => (
                                            <div className="col-md-12 search-result" style={{ marginTop: '35px' }}>
                                                <div className="title row">
                                                    <div className="col-md-6" style={{ paddingLeft: 'unset', fontSize: '17px' }}>
                                                        <p className='name' style={{ fontSize: "16px" }}>{post.userid} <span style={{ fontSize: "18px" }}> - {post.mname}</span></p>
                                                    </div>

                                                    <div
                                                        className="col-md-6 d-flex align-items-center justify-content-end"
                                                        style={{ paddingRight: 'unset', fontSize: '17px' }}
                                                    >
                                                        {isLoggedIn && (
                                                            <div className="d-flex align-items-center">
                                                                {/* The Premium Icon placed here, before the Saved button/text */}
                                                                {post.membership === "VIP" && (
                                                                    // <WorkspacePremiumIcon style={{ margin: "0 10px 0 0", color: "#AA6C39", fontSize: "18px" }} />
                                                                    <span style={{ margin: "0 10px 0 0", fontSize: "28px" }}>
                                                                        👑
                                                                    </span>
                                                                )}

                                                                <button
                                                                    onClick={() => savefavprofile(post._id)}
                                                                    className='drink'
                                                                    disabled={savedProfiles.has(post._id)}
                                                                    // Add margin-right to separate it from View Profile button
                                                                    style={{ marginRight: '10px' }}
                                                                >
                                                                    {savedProfiles.has(post._id) ? 'Saved' : 'Save Profile'}
                                                                    <FavoriteIcon style={{ fontSize: '14px', margin: "0px 0px 0px 8px" }} />
                                                                </button>
                                                            </div>
                                                        )}

                                                        {/* View Profile should be the last item on the right */}
                                                        <a href={"/batman/" + post._id} className='buttonsss'>View Profile</a>
                                                    </div>

                                                </div>
                                                <hr style={{ marginTop: '-10.1px' }} />
                                                <div className="row " >
                                                    <div className="col-md-2" >
                                                        <a href={"/batman/" + post._id}>
                                                            <img src={post.photopath.length && post.photopath[0] ? config.API + "/images/user/" + post.photopath[0] : post.sex == "Male" ? require('../../assests/images/man.png') : require('../../assests/images/woman.png')} alt="Profile" className="img-responsive" style={{ height: "200px" }} /></a>
                                                    </div>
                                                    <div className="col-md-5 content">

                                                        <table className='Droid Sans' style={{ width: '100%', fontSize: '17px', fontFamily: 'fantasy' }}>

                                                            <tbody>

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Gender </b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.sex == 'Male' ? "Male" : "Female"}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Age</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.age = new Date().getFullYear() - post.year + "" + " Yrs"}</td>
                                                                </tr>
                                                                {/* <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Date of birth</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.dob = post.date + "-" + post.month + "-" + post.year}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Father Name</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', marginLeft: '10px', paddingBottom: "10px", color: "#000000" }}>{post.father_name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Mother Name</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.mother_name}</td>
                                                                </tr> */}

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Religion</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.religion}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Caste</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.castename}</td>
                                                                </tr>

                                                                {/* <tr>
                                            <td style={{ color: '#000', textAlign: 'left', paddingBottom:"10px" }}><b>நட்சத்திரம் </b></td>
                                            <td style={{ width: '22px' , paddingBottom:"10px"}}>:</td>
                                            <td style={{ textAlign: 'left', paddingBottom:"10px" }}> {post.starname}</td>
                                        </tr> */}
                                                            </tbody></table>

                                                    </div>
                                                    <div className="col-md-5 content">
                                                        <table className='Droid' style={{ width: '100%', fontSize: '17px' }}>
                                                            <tbody>
                                                                {/* <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Zodiac</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.zodiacname}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Star</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.starname}</td>
                                                                </tr> */}
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Job</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    {/* <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.occup && (occupations.some(item => item.title === post?.occup) ? post?.occup : post?.occup + " (Others)")}</td> */}
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.occup}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Education</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    {/* <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.educ && (educationOptions.some(item => item.title === post?.educ) ? post?.educ : post?.educ + " (Others)")}</td> */}
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.educ}</td>
                                                                </tr>
                                                                {/* <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Height</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.height}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>District</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.city} </td>
                                                                </tr> */}
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Sub Caste </b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.subcaste}</td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                        <div class="topright-hide" style={{ textAlign: 'right' }}>
                                                            <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow"
                                                                style={{ width: '21%', marginTop: '-35px', marginRight: '-8px' }}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        ))
                                            :
                                            <div class="empty-state__content">
                                                <div class="empty-state__icon">
                                                    <img src={require('../../assests/img/norec.png')} alt="" />
                                                </div>
                                                <div class="empty-state__message">No Profiles Found.</div>
                                            </div>
                                    }
                                </div>
                                // </InfiniteScroll>
                            )}
                            {shouldShowPagination && (
                                <div className="row mt-5 mb-4">
                                    <div className="col-12 text-center">
                                        <Pagination
                                            count={totalPages || 1}
                                            page={page}
                                            onChange={handlePageChange}
                                            color="primary"
                                            size="large"
                                            showFirstButton
                                            showLastButton
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div >
            </div >

        </>
    )
}

export default Freesearch;
